import { isPdfPrintVersion } from "./pdfPrintVersion";
import "./ivyprestoFonts.scss";

export const loadPrintCommonStyles = () => {
  if (isPdfPrintVersion()) {
    require("./pdfprintCommon.scss");
  } else {
    require("./printCommon.scss");
  }
};
